import React, {PureComponent} from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import generalActions from 'redux/actions/generalActions'
import myLibraryActions from 'redux/actions/my_library_actions'

const CONFIRM_TYPE = confirmTypes.MY_LIBRARY_PREMIUM_FEATURE_UPGRADE

class MyLibraryPremiumfeatureUpgradeConfirm extends PureComponent {

	actionSelected(button) {
		this.props.actions.homeworkUpgradeSelected(this.props.sessionData, button, this.props.isIframeView)
	}

	render() {
		const props = this.props
		const buttons = props.sessionData.hwTrial.buttons
		return (
			<Confirm
				btOne={buttons[0].text}
				btTwo={buttons[1].text}
				alertTitle={props.sessionData.hwTrial.offerTitle}
				alertMessage={props.sessionData.hwTrial.offerMessage}
				actionButtonType={0}
				actionOne={this.actionSelected.bind(this, buttons[0])}
				actionTwo={this.actionSelected.bind(this, buttons[1])}
				centeredTitle={true}
				centeredMessage={true}
				closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
		homeworkUpgradeSelected: myLibraryActions.homeworkUpgradeSelected,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryPremiumfeatureUpgradeConfirm)

export { MyLibraryPremiumfeatureUpgradeConfirm }
